module.exports = __webpack_public_path__ + "logo-3dcart.9b553ea9675c3ec6de71559a7b5cf6a2.svg";